import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import { useGsapReveal } from "@/hooks/useGsapReveal";

export default function Layout() {
  const { pathname } = useLocation();
  useGsapReveal(pathname);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col" data-testid="app-layout" data-gsap="page">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
